import { Alert } from "@chakra-ui/react";
import { type FC, type ReactNode } from "react";
import {
  LuCircleAlert,
  LuCircleCheck,
  LuInfo,
  LuTriangleAlert,
} from "react-icons/lu";

type NotificationStatus = "error" | "success" | "warning" | "info";

const statusIcon = {
  error: LuCircleAlert,
  success: LuCircleCheck,
  warning: LuTriangleAlert,
  info: LuInfo,
} as const;

interface Props extends Partial<Alert.RootProps> {
  status?: NotificationStatus;
  message?: string | null;
  children?: ReactNode;
}

export const NotificationBlock: FC<Props> = ({
  status = "info",
  message,
  children,
  ...props
}) => {
  const content = children ?? message;

  if (!content) return null;

  return (
    <Alert.Root status={status} w="full" {...props}>
      <Alert.Indicator as={statusIcon[status]} />
      <Alert.Description textAlign="start">{content}</Alert.Description>
    </Alert.Root>
  );
};
